/*
|-----------------------------------------
| IE11 startsWith() Polyfill
|-----------------------------------------
| https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
|
*/
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, "startsWith", {
    value: function (search, rawPos) {
      var pos = rawPos > 0 ? rawPos | 0 : 0;
      return this.substring(pos, pos + search.length) === search;
    },
  });
}

/*
|-----------------------------------------
| Document Ready
|-----------------------------------------
*/
$(document).ready(function () {
  /*
  |-----------------------------------------
  | Identify Mobile
  |-----------------------------------------
  | For this site 'mobile' is defined as a
  | device with screen size of 800px or less.
  |
  */
  var isMobile = function () {
    if (window.innerWidth <= 800) {
      $("body").addClass("is-mobile");
      return true;
    } else {
      $("body").removeClass("is-mobile");
      return false;
    }
  };
  $(window).on("resize", function () {
    isMobile();
  });
  isMobile();

  /*
  |-----------------------------------------
  | Departments Menu
  |-----------------------------------------
  | Operates the departments nav.
  |
  */
  if (isMobile() == true) {
    $("#departments").on("click", "a", function (event) {
      var $parent = $(this).parent("li");
      $parent.closest("ul").find("ul").addClass("menu-hide");
      $parent.siblings().removeClass("active");
      if ($parent.hasClass("has-subcategories")) {
        event.preventDefault();
        $parent.find("ul").first().removeClass("menu-hide");
        // $("body").addClass("nav-open");
      }
      $parent.addClass("active");
      $("nav").addClass("open");
    });
  }

  // The "back" button displayed on MOBILE devices.
  $(".js--department-menu-back").click(function () {
    var $menu = $(this).closest("ul");
    $("#departments-menu .has-children").removeClass("open");
    $menu.addClass("menu-hide");
  });

  // Toggle department menu on MOBILE devices
  $("body").on("click", ".js--department-menu-close", function () {
    toggleDeptMenu();
  });

  // Close menu when clicked outside of it
  $(document).on("click", function (e) {
    var clickedTarget = $(e.target);
    var clickedTargetParent = clickedTarget.parent().prop("tagName");
    if (isMobile() == false) {
      if ($("body").hasClass("nav-open")) {
        if (
          clickedTargetParent != "LI" &&
          clickedTargetParent != "A" &&
          clickedTargetParent != "UL" &&
          clickedTargetParent != "SPAN"
        ) {
          closeMenuDesktopHome();
        }
      }
    }
  });

  /*
  |--------------------------------------------------------------------------
  | Navigation
  |--------------------------------------------------------------------------
  |
  | Adjusts the dropdown navigation so menus on the right hand side do not
  | overflow off the page.
  |
  */
  var navBoundary = function () {
    $(".department-categories > li").each(function (index) {
      // Width of the page
      var pageWidth = $("body").width();

      // Position of the current first-tier item
      var item = $(this).position();

      // Width of the immediate dropdown with this item
      var $dropdown = $(this).find("ul:first");
      var width = $dropdown.width();

      // The position of the right hand side of the dropdown menu.
      // Allow for two menus side-by-side where applicable.
      var childMenus = $(this).find(".has-subcategories").length;
      var maxLeft = Math.ceil(item.left + width);
      if (childMenus > 0) {
        var maxLeft = Math.ceil(item.left + width * 2);
      }

      // Add class to those dropdowns to close to the page boundary
      if (isMobile() === false) {
        if (maxLeft > pageWidth || (maxLeft > pageWidth && childMenus > 0)) {
          $dropdown.addClass("adjust");
        } else {
          $dropdown.removeClass("adjust");
        }
      }
    });
  };
  $(window).on("resize load", function () {
    navBoundary();
  });

  /*
  |-----------------------------------------
  | Prevent Click
  |-----------------------------------------
  | Prevents default click event on elements.
  |
  */
  $(".js--noclick-mobile").on("click", function (event) {
    if (isMobile()) {
      event.preventDefault();
    }
  });

  $(".js--noclick").on("click", function (event) {
    event.preventDefault();
  });

  /*
  |-----------------------------------------
  | Tabs
  |-----------------------------------------
  | Simple tabs
  |
  */
  $(".tabbed-section:not(.nodefault) .tabs > li:first-child").addClass("tab-active");
  $(".tabbed-section .tab-content:not(:first)").addClass("tab-closed");

  $(".tabs a").each(function (index, el) {
    var title = $(el).text();
    var tab = $(el).attr("href");
    $(el).attr("data-id", "#" + handleize(title));
    if (tab.startsWith("#")) {
      $(tab).prepend('<a class="tab-title" href="' + tab + '">' + title + "</a>");
    } else {
      var tabId = $(el).attr("data-id");
      $(tabId).prepend('<a class="tab-title" href="' + tab + '">' + title + "</a>");
    }
  });

  $(".tabbed-section").on("click", ".tabs a, .tab-title", function (event) {
    var $parent = $(this).closest(".tabbed-section");
    var $tabs = $(this).closest(".tabs");
    var $tabId = $(this).attr("href");
    if ($tabId.startsWith("#")) {
      event.preventDefault();

      // Highlight the active tab on desktop
      if ($parent.hasClass("tabs-horizontal")) {
        $tabs.find("li").removeClass("tab-active");
        $(this).parent().addClass("tab-active");
      }

      // Open or toggle tab
      if ($parent.hasClass("tabs-horizontal") && isMobile() === false) {
        $(".tab-content", $parent).addClass("tab-closed");
        $($tabId).removeClass("tab-closed");
      } else {
        $($tabId).toggleClass("tab-closed");
      }
    }
  });

  /*
  |-----------------------------------------
  | Conditions Tabs
  |-----------------------------------------
  | Tabs to switch the conditions on the
  | homepage.
  |
  */
  $("#home-guides").on("click", ".tag", function (event) {
    event.preventDefault();
    var $target = $(this).attr("href");
    $("#home-guides .tag").removeClass("tag-active");
    $(this).addClass("tag-active");
    $(".home-guides-list").addClass("hide-mobile");
    $($target).removeClass("hide-mobile");
  });

  /*
  |-----------------------------------------
  | Conditions Selector
  |-----------------------------------------
  | Displays the selected set of conditions on
  | the mobile "guides by condition" page.
  |
  */
  $(".js--conditions-selector").on("change", function () {
    var conditionsSet = "." + $(this).val();
    var $parent = $(this).closest(".tab-content");
    $(".guides-list-links", $parent).addClass("hide-mobile");
    $(conditionsSet, $parent).removeClass("hide-mobile");
  });

  /*
  |-----------------------------------------
  | Load Next Page (Ajax)
  |-----------------------------------------
  | Load the next page of a paginated set into
  | the container with id #js--page.
  |
  */
  $("body").on("click", ".js--next-page", function () {
    var ajaxUrl = $(this).attr("data-next-page");
    var $page = $("#js--page");
    var $btnContainer = $(this).parent();
    $(this).addClass("button-light").text("Loading more...").prop("disabled", true);
    $.ajax({
      type: "get",
      url: ajaxUrl,
      dataType: "html",
      success: function (response) {
        $btnContainer.remove();
        $(response).hide().appendTo($page).fadeIn();
        if (ajaxUrl.includes("/search")) {
          // Rebuild the query params.
          let searchUrl = ajaxUrl.replaceAll("&view=ajax-grid", "&view=grid").replaceAll("&view=ajax", "");
          history.pushState(null, null, searchUrl);
        }
      },
    });
  });

  /*
  |-----------------------------------------
  | Product Options Selector
  |-----------------------------------------
  | Operates the product option dropdowns on
  | the product page.
  |
  */
  var options = [];
  options[1] = null;
  options[2] = null;
  options[3] = null;

  var vatRate = 1.2;
  var variant = null;
  var cartIcon =
    '<svg class="valign spacer-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23" height="18" version="1.1" viewBox="0 0 29 23"><title>Fill 12</title><g id="Symbols" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1"><g id="Icon/Cart" fill="#FFF"><path id="Fill-12" d="M24.9710526,14.8965789 L28.3421053,5.09842105 C28.5078947,4.62394737 28.3815789,4.37447368 28.2473684,4.18657895 C27.8921053,3.705 27.1736842,3.71842105 27.0394737,3.71842105 L7.98947368,3.72394737 L7.47631579,1.22526316 C7.34210526,0.668684211 6.93947368,-1.77635684e-15 6.11842105,-1.77635684e-15 L0.765789474,-1.77635684e-15 C0.213157895,-1.77635684e-15 4.90274488e-13,0.539210526 4.90274488e-13,1.04763158 L4.90274488e-13,2.40947368 C4.90274488e-13,2.89973684 0.205263158,2.74184211 0.781578947,2.74184211 L5.30526316,2.74184211 L8.76315789,17.2519737 C8.21052632,17.8214211 7.91842105,18.7227632 7.91842105,19.4979474 C7.91842105,21.2018684 9.3,22.6653947 11.0763158,22.6653947 C12.75,22.6653947 13.9973684,21.0245526 14.2026316,20.1104211 L20.9447368,20.1104211 C21.1421053,21.0245526 22.1605263,22.7366842 24.0710526,22.7366842 C25.8078947,22.7366842 27.2289474,21.3334737 27.2289474,19.6323158 C27.2289474,17.9393684 26.1789474,16.3332632 24.0868421,16.3332632 C23.2184211,16.3332632 22.1921053,16.4548421 21.7105263,17.3689737 L13.4368421,17.3689737 C12.8289474,16.4548421 12.0157895,16.1705526 11.1789474,16.1394474 L11.0684211,15.54 L23.6684211,15.54 C24.6157895,15.54 24.7973684,15.3442105 24.9710526,14.8965789 Z M9.84473684,19.6661053 C9.84473684,19.0180263 10.3894737,18.4905789 11.0526316,18.4905789 C11.7078947,18.4905789 12.2447368,19.0180263 12.2447368,19.6661053 C12.2447368,20.3142632 11.7078947,20.8407632 11.0526316,20.8407632 C10.3894737,20.8407632 9.84473684,20.3142632 9.84473684,19.6661053 Z M24.0947368,20.8261579 C23.4394737,20.8261579 22.9105263,20.3051053 22.9105263,19.6652368 C22.9105263,19.0253684 23.4394737,18.5043158 24.0947368,18.5043158 C24.75,18.5043158 25.2789474,19.0244211 25.2789474,19.6652368 C25.2789474,20.3051053 24.75,20.8261579 24.0947368,20.8261579 Z"/></g></g></svg>';
  var availableBtnMessage = cartIcon + " Add to basket";
  var unavailableBtnMessage = "Unavailable";
  $("body").on("change", ".js--variant-option", function () {
    var $parentForm = $(this).closest("form");
    $(".js--variant-option", $parentForm).each(function (index, el) {
      $(el).parent("label").removeClass("checked");
      if ($(el).is(":checked") || $(el).attr("type") == "hidden") {
        var optionName = $(el).attr("name");
        var optionPos = parseInt(optionName.replace("option", ""));
        var optionValue = $(el).val();
        options[optionPos] = optionValue;
        $(el).parent("label").addClass("checked");
      }
    });

    // Check availability of selected variant
    var availability = checkAvailability(options);
    if (availability === false) {
      $(".js--addtobasket").prop("disabled", true).text(unavailableBtnMessage);
    } else {
      $(".js--addtobasket").prop("disabled", false).html(availableBtnMessage);
    }

    var sisterOptions = options;
    $.each(variants, function (index, v) {
      if (v.option1 == options[1] && v.option2 == options[2] && v.option3 == options[3]) {
        variant = v;

        // Display the variant image, if set.
        if (variant.featured_image != null) {
          let variantImageId = variant.featured_media.id;
          let variantImageSrc = $('.js--product-thumb[data-imageid="' + variantImageId + '"]').data("src");
          if (variantImageSrc != null) {
            $(".js--product-image-full").attr("src", variantImageSrc);
            $("figure.zoom").css("background-image", "url(" + variantImageSrc + ")");
          }
        }

        // Show the correct prices and sku. For accuracy, get the sister
        // variant's price, i.e. if exclusive, get the price of the
        // inclusive variant too.
        if ($.inArray("Exclusive", options) >= 0) {
          var inclusiveIndex = $.inArray("Exclusive", options);
          sisterOptions[inclusiveIndex] = "Inclusive";
          var sisterVariant = searchVariants(sisterOptions);
          // console.log({variant, sisterVariant});
          var priceWithVat = sisterVariant.price / 100;
          var priceWithoutVat = variant.price / 100;
          var compareAtPriceWithVat = sisterVariant.compare_at_price / 100;
          var compareAtPriceWithoutVat = variant.compare_at_price / 100;
          var withVatId = sisterVariant.id;
          var withoutVatId = variant.id;
        } else if ($.inArray("Inclusive", options) >= 0) {
          var inclusiveIndex = $.inArray("Inclusive", options);
          sisterOptions[inclusiveIndex] = "Exclusive";
          var sisterVariant = searchVariants(sisterOptions);
          // console.log({v, sisterVariant});
          priceWithVat = variant.price / 100;
          priceWithoutVat = sisterVariant.price / 100;
          var compareAtPriceWithVat = variant.compare_at_price / 100;
          var compareAtPriceWithoutVat = sisterVariant.compare_at_price / 100;
          var withVatId = variant.id;
          var withoutVatId = sisterVariant.id;
        } else if ($.inArray("Inclusive", options) === -1 && $.inArray("Exclusive", options) === -1) {
          var priceWithVat = variant.price / 100;
          var priceWithoutVat = variant.price / vatRate;
          var compareAtPriceWithVat = variant.compare_at_price / 100;
          var compareAtPriceWithoutVat = variant.compare_at_price / vatRate;
        }

        // Update price, sku, etc. on the page
        $(".js--product-sku").text(variant.sku);
        $(".js--price-with-vat").text(moneyWithCurrency(priceWithVat));
        $(".js--price-without-vat").text(moneyWithCurrency(priceWithoutVat));
        if (compareAtPriceWithVat > priceWithVat) {
          $(".js--compareatprice-with-vat").html("<span>Was " + moneyWithCurrency(compareAtPriceWithVat) + "</span>");
          $(".js--compareatprice-without-vat").html(
            '<span style="vertical-align:baseline;">Was ' + moneyWithCurrency(compareAtPriceWithoutVat) + "</span>"
          );
        } else {
          $(".js--compareatprice-with-vat").html("");
          $(".js--compareatprice-without-vat").html("");
        }

        // Set the variant id data attributes on the add to basket button
        $(".js--addtobasket").attr("data-with-vat-id", withVatId);
        $(".js--addtobasket").attr("data-without-vat-id", withoutVatId);

        // Update variant id field
        $(".js--variant-id", $parentForm).val(variant.id);

        // Disable the buy button if product is unavailable
        if (v.available === false) {
          $(".js--addtobasket").prop("disabled", true).text(unavailableBtnMessage);
        } else {
          $(".js--addtobasket").prop("disabled", false).html(availableBtnMessage);
        }

        // Update the buy together item
        var $thisBtItemCheckbox = $("#js--bt-this-item").find(".js--bt-item-id");
        var $thisBtItemTitle = $("#js--bt-this-item").find(".js--bt-item-title");
        var thisBtTitle = variant.name.replace("/ Exclusive", "").replace("/ Inclusive", "");
        var thisBtPriceWithoutVat = moneyWithCurrency(priceWithoutVat) + " with VAT Relief";
        var thisBtPriceWithVat = "(" + moneyWithCurrency(priceWithVat) + " inc VAT)";
        if ($("#js--bt-this-item").find(".js--bt-item-pricewithoutvat").length == 0) {
          thisBtPriceWithVat = moneyWithCurrency(priceWithVat) + " inc VAT";
        }
        $("#js--bt-this-item").find(".js--bt-item-pricewithoutvat").text(thisBtPriceWithoutVat);
        $("#js--bt-this-item").find(".js--bt-item-pricewithvat").text(thisBtPriceWithVat);
        $thisBtItemCheckbox.val(variant.id);
        $thisBtItemCheckbox.attr("data-id-with-vat", withVatId);
        $thisBtItemCheckbox.attr("data-id-without-vat", withoutVatId);
        $thisBtItemCheckbox.attr("data-price-with-vat", priceWithVat);
        $thisBtItemCheckbox.attr("data-price-without-vat", priceWithoutVat);
        $thisBtItemTitle.text(thisBtTitle);

        // Stock message
        var stockLevel = stock[v.id];
        var stockStatusColour = "green";
        var stockStatus = "In stock.";
        var stockMessage = "This product is in stock and ready for immediate dispatch.";
        if (v.available == true) {
          $(".js--stock-times").removeClass("hide");
          if (stockLevel > 0 && stockLevel < 5) {
            stockStatusColour = "red";
            stockStatus = "Limited stock.";
            stockMessage = "Only " + stockLevel + " left in stock - more arriving soon.";
          }
        } else {
          $(".js--stock-times").removeClass("hide");
          stockStatusColour = "red";
          stockStatus = "Out of stock.";
          stockMessage = "This product is out of stock. Contact us to find out when this item will be available.";
        }
        $(".js--stock-status").removeClass("red green").addClass(stockStatusColour).text(stockStatus);
        $(".js--stock-message").text(stockMessage);

        // Append the variant ID as a url parameter
        if (v != undefined) {
          if (historyState()) {
            window.history.replaceState({}, document.title, "?variant=" + v.id);
          }
        }
        return false;
      }
    });
    updateBuyTogether();
  });

  /*
  |-----------------------------------------
  | Check Availability
  |-----------------------------------------
  | Check the availability of the selected
  | variant. Returns true if available, i.e.
  | the variant exists.
  |
  */
  var checkAvailability = function (options) {
    var availability = false;
    variants.filter(function (variant) {
      if (variant.option1 == options[1] && variant.option2 == options[2] && variant.option3 == options[3]) {
        availability = true;
      }
    });
    return availability;
  };

  /*
  |-----------------------------------------
  | Number Input Stepper
  |-----------------------------------------
  | Operates the increment/decrement stepper
  | buttons on the number input.
  |
  */
  var maxQty = 20;
  var minQty = 1;
  $("body").on("click", ".js--qty-increase, .js--qty-decrease", function (event) {
    event.preventDefault();
    var $input = $(this).closest(".js--qty-update").find("input");
    var currentValue = parseInt($input.val());
    var maxValue = $input.attr("max") !== undefined ? parseInt($input.attr("max")) : maxQty;
    var minValue = $input.attr("min") !== undefined ? parseInt($input.attr("min")) : minQty;
    if ($(this).hasClass("js--qty-increase")) {
      if (currentValue < maxValue) {
        $input.val(currentValue + 1);
      }
    }
    if ($(this).hasClass("js--qty-decrease")) {
      if (currentValue > minValue) {
        $input.val(currentValue - 1);
      }
    }
    updateCartLineItemQty($input);
  });

  /*
  |-----------------------------------------
  | Cart Item Qty
  |-----------------------------------------
  | If customer manually enters a number instead of
  | using the stepper buttons, check what they have
  | entered is a valid number.
  |
  */
  $(".js--qty").on("input", function () {
    var currentValue = $(this).val();
    var maxValue = $(this).attr("max") !== undefined ? parseInt($(this).attr("max")) : maxQty;
    var minValue = $(this).attr("min") !== undefined ? parseInt($(this).attr("min")) : minQty;
    // Ensure customer can't enter invalid quantities
    if (currentValue < minValue) {
      $(this).val(minValue);
    }
    if (currentValue > maxValue) {
      $(this).val(maxValue);
    }
    // Update totals
    if (Number.isNaN(currentValue) === false) {
      updateCartLineItemQty($(this));
    }
  });

  /*
  |-----------------------------------------
  | Frequently Bought Together
  |-----------------------------------------
  | Updates the totals and variant ids, etc when
  | the buy together items are interacted with.
  | At least one item should always be checked.
  |
  */
  $("body").on("click", ".js--bt-item-id", function () {
    var count = $(".js--bt-item-id:checked").length;
    if (count == 0) {
      return false;
    }
    updateBuyTogether();
  });

  /*
  |-----------------------------------------
  | Remove Cart Item
  |-----------------------------------------
  | Displays user a modal confirmation to remove
  | item from their cart.
  |
  */
  $(".js--cart-item-remove").on("click", function (event) {
    event.preventDefault();
    var link = $(this).attr("href");
    var lineItemKey = $(this).data("item-key");
    var lineItemId = $(this).data("variant-id");
    var settings = {
      title: "Remove Item?",
      showTitle: true,
      acceptBtnLabel: "Yes, remove item",
      cancelBtnLabel: "No, keep the item in my basket",
      cancelBtnLink: false,
      showCloseBtn: true,
      width: 500,
      fadeDuration: 400,
      onActivate: function () {},
      onOpen: function () {},
      onClose: function () {},
    };
    var modalContent = '<p class="center">Are you sure you want to remove this item from your basket?</p>';
    openModal(modalContent, settings, function () {
      var items = { updates: {} };
      items.updates[lineItemId] = 0;
      // Find any attached gift wrap product so it can also be removed
      $.getJSON("/cart.json", function (cart) {
        cart.items.filter(function (item) {
          if (item.properties) {
            if (item.properties["_id"] == lineItemKey) {
              items.updates[item.id] = 0;
              return false;
            }
          }
        });
        $.ajax({
          type: "post",
          url: "/cart/update.js",
          dataType: "json",
          data: items,
          success: function (response) {
            window.location.href = "/cart";
          },
        });
      });
    });
  });

  /*
  |-----------------------------------------
  | Return to top
  |-----------------------------------------
  | Displays 'return to top' link in the bottom
  | corner of the screen.
  |
  */
  $(window).scroll(function () {
    if ($(this).scrollTop() > 600) {
      if ($("#return-top").length === 0) {
        $("body").append('<a id="return-top" class="desktop desktop-large" title="Return to top"></a>');
      }
      $("#return-top").fadeIn();
    } else {
      $("#return-top").fadeOut(function () {
        $(this).remove();
      });
    }
    // Return to top scroll button
    $("body").on("click", "#return-top", function () {
      $("html, body").animate({ scrollTop: 0 }, 600, function () {
        $(this).clearQueue();
        $(this).stop();
      });
      return false;
    });
  });

  /*
  |-----------------------------------------
  | Ihavecookies
  |-----------------------------------------
  | Cookie consent modal.
  |
  */
  var ihavecookiesOptions = {
    title: "Cookies",
    message: "By using this website, you agree to ",
    link: "/pages/privacy-policy",
    moreInfoLabel: "our privacy policy",
    acceptBtnLabel: "OK",
    advancedBtnLabel: "Customise",
    delay: 400,
    cookieTypes: [
      {
        type: "Analytics",
        value: "analytics",
        description: "Cookies related to site visits, browser types, etc.",
      },
    ],
  };
  $("body").ihavecookies(ihavecookiesOptions);
  $("#ihavecookiesOpen").click(function (event) {
    event.preventDefault();
    $("body").ihavecookies(ihavecookiesOptions, "reinit");
  });

  /*
  |-----------------------------------------
  | Collection Featured Product
  |-----------------------------------------
  | Hides the featured product on the collection page,
  | if there's nothing to show i.e. its contents is
  | empty. And, sets the collection description to
  | full width.
  |
  */
  if ($("#js--collection-featured-product #featured-product").length == 0) {
    $("#js--collection-featured-product").removeClass("col4").addClass("collapse");
    $("#js--collection-description").removeClass("col8").addClass("col12");
  }

  /*
  |-----------------------------------------
  | Prevent Widows
  |-----------------------------------------
  | Prevents widows on headings.
  | https://css-tricks.com/preventing-widows-in-post-titles/
  |
  */
  $(".nowidows").each(function () {
    var wordArray = $(this).html().split(" ");
    if (wordArray.length > 1) {
      wordArray[wordArray.length - 2] += "&nbsp;" + wordArray[wordArray.length - 1];
      wordArray.pop();
      $(this).html(wordArray.join(" "));
    }
  });

  /*
  |-----------------------------------------
  | Q&As
  |-----------------------------------------
  | Toggles question/answers on the meet the
  | team page.
  |
  */
  $(".js--qa-go").on("click", function () {
    var $parent = $(this).closest(".js--qa-container");
    var index = $(this).data("go");
    $parent.find(".dots li").removeClass("active");
    $(this).parent("li").addClass("active");
    $parent.find(".js--qa").hide();
    $parent.find('.js--qa[data-index="' + index + '"]').fadeIn("slow");
  });

  /*
  |-----------------------------------------
  | Gift Wrap Option
  |-----------------------------------------
  | Manages the gift wrap option in the cart.
  |
  */
  $(".js--gift-wrap").on("click", function () {
    var $this = $(this);
    var lineItemTitle = $this.data("item-title");
    var lineItemKey = $this.val();
    if ($this.prop("checked")) {
      addGiftWrap(lineItemTitle, lineItemKey);
    } else {
      removeGiftWrap(lineItemKey);
    }
  });

  /*
  |-----------------------------------------
  | Responsive YouTube Videos
  |-----------------------------------------
  | Makes youtube videos within the product description
  | fully responsive by wrapping the iframe in a div with
  | the class "youtube-video-container".
  |
  */
  $("#description .wysiwyg :not(.youtube-video-container) iframe").wrap('<div class="youtube-video-container"></div>');

  /*
  |-----------------------------------------
  | Back to Search Results link
  |-----------------------------------------
  | Populates the "back to results" link on the
  | product page if the querystring param "b" exists.
  |
  */
  if (getParam("b") !== null) {
    let backUrl = getParam("b");
    let listItem = `<li id="js--back-search" class="tablet desktop desktop-large red spacer-left-large"><a href="${backUrl}">Back to results</a></li>`;
    $("#breadcrumb li:last-child()").addClass("exclude");
    $("#breadcrumb").append(listItem);
  }

  /*
  |-----------------------------------------
  | Mobile Footer
  |-----------------------------------------
  | Tab the footer for mobiles.
  |
  */
  function mobileFooter() {
    if (isMobile() == true) {
      const footer = document.querySelector(".js--footer-columns");
      let footerCols = footer.querySelectorAll(".col3");
      let associations = footer.querySelector("#associations");
      let associationsHtml = associations.innerHTML;
      associations.remove();
      document.getElementById("copyright").insertAdjacentHTML(
        "beforebegin",
        `<ul class="flex center" style="gap:10px;">
        ${associationsHtml}
      </ul>`
      );
      footerCols.forEach(function (el) {
        let heading = el.querySelector("h4");
        let title = heading.innerText;
        let content = el.querySelector("ul").innerHTML;
        let html = `
        <details>
          <summary class="white regular heading">${title}</summary>
          <div class="white nomargin spacer-bottom-large">
            <ul>
              ${content}
            </ul>
          </div>
        </details>
      `;
        el.innerHTML = html;
      });
    }
  }
  mobileFooter();
});

/*
|-----------------------------------------
| Add Gift Wrap Item
|-----------------------------------------
| Adds gift wrap product to cart.
|
| @param lineItemTitle - Product title of the cart line item
| @param lineItemKey - Cart line item key
|
*/
var addGiftWrap = function (lineItemTitle, lineItemKey) {
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      items: [
        {
          id: giftWrap.id,
          quantity: 1,
          properties: {
            Item: lineItemTitle,
            _id: lineItemKey,
          },
        },
      ],
    },
    success: function (cartItem) {
      $.getJSON("/cart.json", function (cart) {
        $(".js--cart-item-count").text(cart.item_count);
        $(".js--cart-subtotal").text(moneyWithCurrency(cart.total_price / 100));
        cartSpendMore(cart);
      });
    },
  });
};

/*
|-----------------------------------------
| Remove Gift Wrap Item
|-----------------------------------------
| Removes gift wrap item from the cart by
| setting its quantity to 0.
|
| @param lineItemKey - Cart line item key
| @param callback - Optional callback function
|
*/
var removeGiftWrap = function (lineItemKey, callback) {
  $.getJSON("/cart.json", function (cart) {
    var item = cart.items.filter(function (item) {
      if (item.properties) {
        if (item.properties["_id"] == lineItemKey) {
          $.ajax({
            type: "post",
            url: "/cart/change.js",
            dataType: "json",
            data: {
              id: item.key,
              quantity: 0,
            },
            success: function (cartItem) {
              $.getJSON("/cart.json", function (cart) {
                $(".js--cart-item-count").text(cart.item_count);
                $(".js--cart-subtotal").text(moneyWithCurrency(cart.total_price / 100));
                cartSpendMore(cart);
                if (typeof callback == "function") {
                  callback();
                }
              });
            },
          });
        }
      }
    });
  });
};

/*
|-----------------------------------------
| Filter Variants
|-----------------------------------------
| Filters variants with the passed options.
|
| This is used in the product page variant
| options selector in the code above.
|
*/
var searchVariants = function (options) {
  var v = null;
  variants.filter(function (variant) {
    if (variant.option1 == options[1] && variant.option2 == options[2] && variant.option3 == options[3]) {
      v = variant;
    }
  });
  return v;
};

/*
|-----------------------------------------
| Handleize
|-----------------------------------------
| Javascript version of Shopifys handleize
| function.
|
*/
var handleize = function (str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

/*
|-----------------------------------------
| Format Money
|-----------------------------------------
| Formats the passed value as money with
| currency symbol.
|
*/
var moneyWithCurrency = function (value) {
  if (value != undefined) {
    var string = value.toLocaleString("en-GB", { style: "currency", currency: "GBP" });
    return string;
  }
};

/*
|-----------------------------------------
| Toggles MOBILE Department Menu
|-----------------------------------------
| Toggles the department menu on mobile.
|
*/
var toggleDeptMenu = function () {
  $(".js--department-categories").addClass("menu-hide");
  var myClass = "open-mobile";
  if ($("nav").hasClass(myClass)) {
    $("nav").removeClass(myClass);
  } else {
    $("nav").addClass(myClass);
  }
};

/*
|-----------------------------------------
| Toggles DESKTOP Department Menu
|-----------------------------------------
| Toggles the department menu on tablet and
| desktop devices.
|
*/
var toggleMenuDesktop = function () {
  var $deptMenu = $("#departments-menu");
  $deptMenu.toggleClass("hide-tablet-up");
  if ($("body").hasClass("is-mobile") == false) {
    var menuWidth = $(".department-categories").width();
    $(".department-categories > li > ul").css({ left: menuWidth + "px" });
  }
  if ($deptMenu.hasClass("hide-tablet-up") == false) {
    $("body").addClass("nav-open");
    $("nav").addClass("open");
  } else {
    $("body").removeClass("nav-open");
    $("nav").removeClass("open");
  }
};

/*
|-----------------------------------------
| Close DESKTOP Department Menu
|-----------------------------------------
| Closes the department menu on the desktop.
|
*/
var closeMenuDesktopHome = function () {
  $("nav").removeClass("open");
  $("body").removeClass("nav-open");
  $("li.has-subcategories").removeClass("active");
  $(".js--department-categories").addClass("menu-hide");
};

/*
|-----------------------------------------
| Get URL Parameter
|-----------------------------------------
| Get query string parameter.
| Usage:
|   var variantId = getParam('variant);
|
*/
// Get query string parameter
var getParam = function (name) {
  if ("URLSearchParams" in window) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  } else {
    // Polyfill for IE11
    var params = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href);
    if (params == null) {
      return null;
    } else {
      return decodeURI(params[1]) || 0;
    }
  }
};

/*
|-----------------------------------------
| History State
|-----------------------------------------
| Check if window.history is supported
|
*/
var historyState = function () {
  return window.history && window.history.replaceState;
};

/*
|-----------------------------------------
| Modal
|-----------------------------------------
| Opens a modal popup with accept and cancel
| buttons.
|
| Options:
|  - title: Heading for the modal contents
|  - acceptBtnLabel: Label for the accept button. Set to false
|                    to remove the button.
|  - cancelBtnLabel: Label for the cancel link. Set to false
|                    to remove it.
|  - cancelBtnLink: Default false. If set to a url path, overrides the
|                   default cancel button action of closing the modal.
|  - showCloseBtn: Set to false to remove the X button in the
|                  top corner.
|  - showTitle: Set to false to remove the title.
|  - width: Optional, width in pixels.
|  - fadeDuration: 400.
|  - onActivate: Optional, function to run when modal is activated but
|                before any content is displayed.
|  - onOpen: Optional, function to run when the modal is opened
|            and content is displayed.
|  - onClose: Optional, function to run when modal is closed.
| Callback:
|  - Function to run when the accept button is clicked
|
*/
var openModal = function (content, options, callback) {
  var $d = new $.Deferred();

  // Default settings
  var settings = $.extend(
    {
      title: "Information",
      showTitle: true,
      acceptBtnLabel: "Okay",
      cancelBtnLabel: "Cancel",
      cancelBtnLink: false,
      showCloseBtn: true,
      width: false,
      fadeDuration: 400,
      onActivate: function () {},
      onOpen: function () {},
      onClose: function () {},
    },
    options
  );

  var modalWidth = "";
  if (settings.width !== false && settings.width > 0) {
    modalWidth = ' style="max-width:' + settings.width + 'px;"';
  }

  // Generate the modal html
  var template =
    '<div id="modal">' +
    '<div id="modal-outer" class="rounded"' +
    modalWidth +
    ">" +
    '<div id="modal-inner">' +
    '<div id="modal-header" class="padding black-background">';

  if (settings.showCloseBtn === true) {
    template += '<button id="modal-close" class="js--modal-close" type="button"></button>';
  }

  if (settings.showTitle === true) {
    template += '<h2 class="center h20 white">' + settings.title + "</h2>";
  }
  template += "</div>";

  template += '<div id="modal-content" class="padding">';
  template += content;
  template += "</div>";

  template += '<div id="modal-footer" class="padding center">';
  // Show accept button
  if (settings.acceptBtnLabel !== false) {
    template +=
      '<p class="spacer-bottom"><button id="modal-accept" type="button" class="button">' +
      settings.acceptBtnLabel +
      "</button></p>";
  }

  // Show cancel link
  if (settings.cancelBtnLabel !== false) {
    if (settings.cancelBtnLink === false) {
      template += '<p><a class="js--modal-close red underline" href="#">' + settings.cancelBtnLabel + "</a></p>";
    } else {
      template +=
        '<p><a href="' + settings.cancelBtnLink + '" class="button black">' + settings.cancelBtnLabel + "</a></p>";
    }
  }
  template += "</div>";

  template += "</div>" + "</div>" + "</div>";

  $("body").css({
    overflowY: "scroll",
    position: "fixed",
    width: "100%",
  });

  // Append the modal html to the document body
  $("body").append(
    $(template)
      .hide(function () {
        settings.onActivate.call(this);
      })
      .fadeIn(settings.fadeDuration, function () {
        settings.onOpen.call(this);
      })
  );

  // Accept button
  $("body").on("click", "#modal-accept", function () {
    $d.resolve({
      confirm: true,
    });
    if (typeof callback == "function") {
      callback();
    }
  });

  // Cancel button
  $("body").on("click", ".js--modal-close", function (event) {
    event.preventDefault();
    $d.resolve({
      confirm: false,
    });
    closeModal();
    settings.onClose.call(this);
  });

  return $d.promise();
};

/*
|-----------------------------------------
| Close Modal
|-----------------------------------------
| Removes modal from DOM.
|
*/
var closeModal = function () {
  $("#modal").fadeOut(function () {
    $(this).remove();
    $("body").css({
      overflowY: "",
      position: "",
      width: "",
    });
  });
};

/*
|-----------------------------------------
| Confirm VAT Exemption
|-----------------------------------------
| Opens modal when the add the basket button
| is clicked on the product page. This does
| not apply to the "buy together" section.
|
*/
var confirmVatExemption = function (el) {
  var $el = $(el);
  var $parentForm = $el.closest("form");
  var idWithVat = parseInt($(".js--addtobasket", $parentForm).data("with-vat-id"));
  var idWithoutVat = $(".js--addtobasket", $parentForm).data("without-vat-id");
  var settings = {
    title: "Are you exempt from paying VAT?",
    showTitle: true,
    acceptBtnLabel: "Confirm & Add Item to Basket",
    cancelBtnLabel: "Close",
    cancelBtnLink: false,
    showCloseBtn: false,
    width: 500,
    fadeDuration: 400,
    onActivate: function () {},
    onOpen: function () {},
    onClose: function () {},
  };

  var modalContent =
    '<form id="modal-form" method="post" action="/cart/add">' +
    '<div class="spacer-bottom-xxlarge center">' +
    '<p class="black bold lh-normal spacer-bottom">Please select:</p>' +
    '<p class="spacer-bottom-large">' +
    '<label for="formVatNo" class="input-with-label black spacer-right-xxlarge"><input id="formVatNo" class="js--modal-id" type="radio" name="id" data-exempt="Yes" value="' +
    idWithoutVat +
    "\" onclick=\"$('#js--vat-declaration').show();$('#js--modal-vat-exempt').val('Yes');\" checked> I don't pay VAT</label>" +
    '<label for="formVatYes" class="input-with-label black"><input id="formVatYes" class="js--modal-id" type="radio" name="id" data-exempt="No" value="' +
    idWithVat +
    "\" onclick=\"$('#js--vat-declaration').hide();$('#js--modal-vat-exempt').val('No');\"> I pay VAT</label>" +
    "</p>" +
    '<p class="spacer-top lh-normal">(Please ensure that you are eligible for VAT exemption — if you are unsure <a class="underline red" href="/pages/vat-exemption">click here for further details</a>.)</p>' +
    "</div>" +
    '<div id="js--vat-declaration">' +
    '<label for="js--modal-vat-exempt-reason" class="black bold">Briefly describe any medical conditions you or the person you are ordering for has in the box below:</label>' +
    '<p class="spacer-top"><textarea id="js--modal-vat-exempt-reason" name="attributes[VAT Exempt Reason]" rows="2"></textarea>' +
    "</div>" +
    '<div class="hide">' +
    '<select id="js--modal-vat-exempt" name="attributes[VAT Exempt]">' +
    '<option value="Yes" selected>Yes</option>' +
    '<option value="No">No</option>' +
    "</select>" +
    "</div>" +
    "</form>";

  openModal(modalContent, settings, function () {
    $("#js--vat-declaration .error").remove();
    if ($("#js--modal-vat-exempt").val() == "Yes" && $("#js--modal-vat-exempt-reason").val().length < 5) {
      $("#js--modal-vat-exempt-reason").css("border-color", "#BC1F31");
      $("#js--modal-vat-exempt-reason")
        .parent("p")
        .prepend('<p class="red error">Please complete the box below (must be more than 5 characters).</p>');
    } else {
      $("form#modal-form").submit();
    }
  });
};

/*
|-----------------------------------------
| Update Cart
|-----------------------------------------
| Update the quantity for a line item in the
| cart. This function is used in the number
| steppers above.
|
*/
var updateCartLineItemQty = function ($input) {
  var lineItemKey = $input.data("lineitem-key");
  var $cartItem = $input.closest(".js--cart-item");
  var lineItemQty = $input.val();
  var $lineItemPrice = $cartItem.find(".js--cart-item-price");
  $.ajax({
    type: "post",
    url: "/cart/change.js",
    data: {
      id: lineItemKey,
      quantity: lineItemQty,
    },
    dataType: "json",
    success: function (cart) {
      cart.items.filter(function (item) {
        if (item.key == lineItemKey) {
          cartItem = item;
        }
      });
      $lineItemPrice.text(moneyWithCurrency(cartItem.final_line_price / 100));
      $(".js--cart-item-count").text(cart.item_count);
      $(".js--cart-subtotal").text(moneyWithCurrency(cart.total_price / 100));
      cartSpendMore(cart);
      if (parseInt(lineItemQty) <= 0) {
        location.reload();
      }
    },
  });
};

/*
|-----------------------------------------
| "Spend more" cart message
|-----------------------------------------
| Displays the "spend more for free delivery" message
| in the cart. This is triggered when a line item qty
| is changed, or when gift wrap is toggled on/off.
|
*/
var cartSpendMore = function (cart) {
  if (cart.total_price >= freeDeliveryAmt) {
    $(".js--cart-postage").text("FREE");
    $(".js--cart-total").text(moneyWithCurrency(cart.total_price / 100));
    $(".js--spend-more").slideUp();
    $(".js--spend-more-amt").text(moneyWithCurrency(0));
  } else {
    $(".js--cart-postage").text(moneyWithCurrency(defaultDeliveryAmt / 100));
    $(".js--cart-total").text(moneyWithCurrency((cart.total_price + defaultDeliveryAmt) / 100));
    $(".js--spend-more").slideDown();
    $(".js--spend-more-amt").text(moneyWithCurrency((freeDeliveryAmt - cart.total_price) / 100));
  }
};

/*
|-----------------------------------------
| Validate Cart
|-----------------------------------------
| Form validation on the vat exemption
| fields in the cart.
|
*/
var validateCart = function (button) {
  var $btn = $(button);
  var success = true;
  $("p.form-error").remove();
  $("input, textarea, select").each(function (i, el) {
    var $input = $(el);
    if ($(el).is(":required")) {
      if ($(el).val() == "") {
        success = false;
        $input.parent().prepend('<p class="red form-error spacer-bottom bold h16">This field is required.</p>');
      }
    }
  });
  if (success == false) {
    $('<p class="red form-error spacer-top bold h16">Please complete the fields highlighted above.</p>').insertAfter(
      $btn
    );
  }
  return success;
};

/*
|-----------------------------------------
| Frequently Bought Together
|-----------------------------------------
| Updates the pricing and variant ids in
| the "buy together" options.
|
*/
var updateBuyTogether = function () {
  var itemCount = 0;
  var totalWithVat = 0;
  var totalWithoutVat = 0;
  var itemCountText = "three";
  var hasVatExempt = false;
  $(".js--bt-item-id").each(function (index, el) {
    var image = $(el).data("tag");
    if ($(el).is(":checked")) {
      itemCount++;
      var vatExempt = $(el).attr("data-vat-exempt");
      var priceWithVat = parseFloat($(el).attr("data-price-with-vat"));
      var priceWithoutVat = parseFloat($(el).attr("data-price-without-vat"));
      totalWithVat += priceWithVat;
      totalWithoutVat += priceWithoutVat;
      $("." + image).removeClass("hide");
      if (itemCount == 1) {
        itemCountText = "one";
      } else if (itemCount == 2) {
        itemCountText = "all two";
      } else {
        itemCountText = "all three";
      }
      $(".js--bt-number").text(itemCountText);
      if (vatExempt == "true") {
        hasVatExempt = true;
      }
    } else {
      $("." + image).addClass("hide");
    }
  });
  $(".js--bt-total").text(moneyWithCurrency(totalWithoutVat) + " with VAT Relief");
  $(".js--bt-totalwithvat").text(moneyWithCurrency(totalWithVat) + " inc VAT");
  // Hide the vat exempt price
  if (hasVatExempt == false) {
    $(".js--bt-total").hide();
    $(".js--bt-totalwithvat").addClass("bold red h18");
  } else {
    $(".js--bt-total").show();
    $(".js--bt-totalwithvat").removeClass("bold red h18");
  }
  // Remove the plus icon
  $(".js--bt-image-large").removeClass("last");
  $(".js--bt-image-large:not(.hide):last").addClass("last");
};

/*
|-----------------------------------------
| Buy Together VAT Modal
|-----------------------------------------
| Displays the vat exemption modal (if applicable) when
| the add to basket button is clicked.
|
*/
var btConfirmVatExemption = function (el) {
  var $el = $(el);
  var $parentForm = $el.closest("form");
  var settings = {
    title: "Are you exempt from paying VAT?",
    showTitle: true,
    acceptBtnLabel: "Confirm & Add Item to Basket",
    cancelBtnLabel: "Close",
    cancelBtnLink: false,
    showCloseBtn: true,
    width: 500,
    fadeDuration: 400,
    onActivate: function () {},
    onOpen: function () {},
    onClose: function () {},
  };

  // Begin putting the form together
  var modalContent = '<form id="modal-form" method="post" action="/cart/add">';

  // Include the vat exempt ids by default because the vat exempt option is pre-checked.
  $(".js--bt-item-id:checked").each(function (index, item) {
    var itemId = $(item).attr("data-id-without-vat");
    modalContent += '<input class="js--modal-id" type="hidden" name="id[]" value="' + itemId + '">';
  });

  modalContent +=
    '<div class="spacer-bottom-xxlarge center">' +
    '<p class="black bold lh-normal spacer-bottom">Please select:</p>' +
    '<p class="spacer-bottom-large">' +
    '<label for="formVatNo" class="input-with-label black spacer-right-xxlarge"><input id="formVatNo" class="js--modal-vat-exempt" type="radio" name="attributes[VAT Exempt]" value="Yes" onclick="$(\'#js--vat-declaration\').show();$(\'#js--modal-vat-exempt\').val(\'Yes\');" checked> I don\'t pay VAT</label>' +
    '<label for="formVatYes" class="input-with-label black"><input id="formVatYes" class="js--modal-vat-exempt" type="radio" name="attributes[VAT Exempt]" value="No" onclick="$(\'#js--vat-declaration\').hide();$(\'#js--modal-vat-exempt\').val(\'No\');"> I pay VAT</label>' +
    "</p>" +
    '<p class="spacer-top lh-normal">(Please ensure that you are eligible for VAT exemption — if you are unsure <a class="underline red" href="/pages/vat-exemption">click here for further details</a>.)</p>' +
    "</div>" +
    '<div id="js--vat-declaration">' +
    '<label for="js--modal-vat-exempt-reason" class="black bold">Briefly describe any medical conditions you or the person you are ordering for has in the box below:</label>' +
    '<p class="spacer-top"><textarea id="js--modal-vat-exempt-reason" name="attributes[VAT Exempt Reason]" rows="2"></textarea>' +
    "</div>" +
    "</form>";

  // Open the modal
  openModal(modalContent, settings, function () {
    $("#js--vat-declaration .error").remove();
    if ($(".js--modal-vat-exempt:checked").val() == "Yes" && $("#js--modal-vat-exempt-reason").val().length < 5) {
      $("#js--modal-vat-exempt-reason").css("border-color", "#BC1F31");
      $("#js--modal-vat-exempt-reason")
        .parent("p")
        .prepend('<p class="red error">Please complete the box below (must be more than 5 characters).</p>');
    } else {
      $("form#modal-form").submit();
    }
  });

  // Update the variant ids depending on the selected vat status option.
  $("body").on("click", "#modal .js--modal-vat-exempt", function () {
    var $thisForm = $(this).closest("form");
    var vatExempt = $(this).val();
    $thisForm.find("input.js--modal-id").remove();
    $(".js--bt-item-id:checked").each(function (index, item) {
      if (vatExempt == "Yes") {
        var itemId = $(item).attr("data-id-without-vat");
      } else {
        var itemId = $(item).attr("data-id-with-vat");
      }
      $thisForm.prepend('<input class="js--modal-id" type="hidden" name="id[]" value="' + itemId + '">');
    });
  });
};

/*
|-----------------------------------------
| Help
|-----------------------------------------
| Opens modal when a help icon is clicked.
|
*/
var launchHelp = function (title, content) {
  var settings = {
    title: title,
    showTitle: true,
    acceptBtnLabel: "Okay",
    cancelBtnLabel: false,
    cancelBtnLink: false,
    showCloseBtn: false,
    width: 500,
    fadeDuration: 400,
    onActivate: function () {},
    onOpen: function () {},
    onClose: function () {},
  };
  openModal(content, settings, function () {
    closeModal();
  });
};

/*
|-----------------------------------------
| Initialise Media Gallery
|-----------------------------------------
| Initialises the slick js sliders in the
| media gallery modal.
|
*/
var initMediaGallery = function (index) {
  $(".media-gallery-image").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    fade: true,
    asNavFor: ".media-gallery-nav",
    initialSlide: index,
    infinite: true,
  });
  $(".media-gallery-nav").slick({
    slidesToShow: 10,
    slidesToScroll: 1,
    asNavFor: ".media-gallery-image",
    dots: false,
    arrows: false,
    draggable: false,
    focusOnSelect: true,
    initialSlide: index,
  });
};

/*
|-----------------------------------------
| Destroy Media Gallery
|-----------------------------------------
| Destroys the slick js sliders in the
| media gallery modal.
|
*/
var destroyMediaGallery = function () {
  $(".media-gallery-image").slick("unslick");
  $(".media-gallery-nav").slick("unslick");
};

/*
|-----------------------------------------
| Open Media Gallery
|-----------------------------------------
| Opens the media gallery modal.
|
*/
var openMediaGallery = function (index = 0) {
  $("#media-gallery").removeClass("hide");
  $("body").css("overflow-y", "hidden");
  initMediaGallery(index);
};

/*
|-----------------------------------------
| Close Media Gallery
|-----------------------------------------
| Closes the media gallery modal.
|
*/
var closeMediaGallery = function () {
  destroyMediaGallery();
  $("#media-gallery").addClass("hide");
  $("body").css("overflow-y", "auto");
};

/*
|-----------------------------------------
| Newsletter Signup Modal
|-----------------------------------------
| Opens modal containing the newsletter
| signup form.
|
*/
var launchNewsletterSignup = function (content) {
  var settings = {
    title: "Join our newsletter",
    showTitle: true,
    acceptBtnLabel: false,
    cancelBtnLabel: false,
    cancelBtnLink: false,
    showCloseBtn: true,
    width: 500,
    fadeDuration: 400,
    onActivate: function () {},
    onOpen: function () {},
    onClose: function () {},
  };
  openModal(content, settings, function () {
    closeModal();
  });
};

/*
|-----------------------------------------
| Clear Cart Attributes
|-----------------------------------------
| Clears the VAT exemption cart attributes.
| This is used for testing only.
|
*/
window.clearCartAttributes = function () {
  return $.ajax({
    type: "post",
    url: "/cart/update.js",
    data: {
      attributes: {
        "VAT Exempt": null,
        "VAT Exempt Reason": null,
      },
    },
    dataType: "json",
    success: function () {
      console.log("Cart attributes cleared.");
    },
  });
};

/*
|-----------------------------------------
| Clear Cart Items
|-----------------------------------------
| Clears cart vat attributes, then all cart
| items and redirect back to current page.
|
*/
var resetCart = function () {
  var currentPageUrl = window.location.href;
  var modalSettings = {
    title: "Update VAT exemption status?",
    showTitle: true,
    acceptBtnLabel: "Change my VAT relief status",
    cancelBtnLabel: "No, leave it as it is",
    cancelBtnLink: false,
    showCloseBtn: true,
    width: 500,
    fadeDuration: 400,
  };
  var modalContent =
    '<p class="center"><strong class="black">Are you sure you want to switch VAT relief status?</strong><br>This will remove all items from your cart.</p>';
  openModal(modalContent, modalSettings, function () {
    clearCartAttributes().then(function () {
      // Remove all cart items
      $.ajax({
        type: "post",
        url: "/cart/clear.js",
        dataType: "json",
        success: function (response) {
          console.log("Removed cart items");
        },
      }).then(function () {
        // Redirect back to current page
        window.location.href = currentPageUrl;
      });
    });
  });
};

/*
|-----------------------------------------
| Fix Product Card Height
|-----------------------------------------
| On the collection page some product card images
| aren't square, so this little bit of js checks
| the height of each cards neighbour and
| sets accordingly if there is a difference.
|
| This function runs on window load.
|
*/
// var autoHeightProductCards = function () {
//   $(".product-card:not(.collection-card)").each(function (index) {
//     var thisCard = $(this).find(".product-card-image").height();
//     var prevCard = $(this).prev().find(".product-card-image").height();
//     var nextCard = $(this).next().find(".product-card-image").height();
//     if (thisCard < prevCard && thisCard < nextCard) {
//       if (prevCard <= nextCard) {
//         $(this)
//           .find(".product-card-image")
//           .css("height", nextCard + "px")
//           .addClass("height-fix");
//       } else {
//         $(this)
//           .find(".product-card-image")
//           .css("height", prevCard + "px")
//           .addClass("height-fix");
//       }
//     }
//   });
// };
// window.onload = function () {
//   autoHeightProductCards();
// };

/*
|-----------------------------------------
| Collection Sort
|-----------------------------------------
| Performs collection sorting.
|
*/
var sortCollection = function (el) {
  Shopify.queryParams = {};
  Shopify.queryParams.sort_by = $(el).val();
  location.search = $.param(Shopify.queryParams);
};

/*
|-----------------------------------------
| Homepage Paginated Collection
|-----------------------------------------
| Pagination products collection on the
| homepage.
|
*/
var pagedSection = function (sectionId) {
  let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  let sectionContainer = document.querySelector(sectionId);
  let productsGrid = sectionContainer.querySelector(".homepage-grid");
  let productCount = productsGrid.querySelectorAll(".product-card").length;
  let productsPerPage = 12;
  if (viewportWidth >= 1025 && viewportWidth <= 1550) {
    productsPerPage = 8;
  }
  if (viewportWidth <= 1024) {
    productsPerPage = 6;
  }
  let totalPages = Math.ceil(productCount / productsPerPage);
  let pagination = "";

  // Hide all products not on the first page.
  productsGrid.querySelectorAll(".product-card").forEach((item, index) => {
    removeClassByPrefix(item, "page");
    removeClassByPrefix(item, "hide");
    let position = index + 1;
    let page = Math.ceil(position / productsPerPage);
    item.setAttribute("data-page", page);
    item.classList.add("page" + page);
    if (position > productsPerPage) {
      item.classList.add("hide");
    }
  });

  // Add pagination at the end of the section.
  for (let i = 1; i <= totalPages; i++) {
    let inActiveBtn = " button-light";
    if (i == 1) {
      inActiveBtn = "";
    }
    pagination += `<button type="button" class="section-page${i} spacer-left spacer-right button${inActiveBtn}" onclick="showPage(${i}, '${sectionId}');">${i}</button>`;
  }
  if (sectionContainer.querySelector(".section-pagination") != null) {
    sectionContainer.querySelector(".section-pagination").remove();
  }
  sectionContainer.insertAdjacentHTML(
    "beforeend",
    `<div class="section-pagination center spacer-top-xlarge">${pagination}</div>`
  );
};

// Show paginated content.
function showPage(n, sectionId) {
  let sectionContainer = document.querySelector(sectionId);
  let productsGrid = sectionContainer.querySelector(".homepage-grid");
  let productCount = productsGrid.querySelectorAll(".product-card").length;
  productsGrid.querySelectorAll(".product-card").forEach((item) => {
    item.classList.add("hide");
  });
  productsGrid.querySelectorAll(".product-card.page" + n).forEach((item) => {
    item.classList.remove("hide");
  });
  sectionContainer.querySelectorAll(".section-pagination > button").forEach((item) => {
    if (item.classList.contains("section-page" + n)) {
      item.classList.remove("button-light");
    } else {
      item.classList.add("button-light");
    }
  });
  document.querySelector(sectionId).scrollIntoView();
}

/*
|-----------------------------------------
| Function to remove classes
|-----------------------------------------
| Helper function to remove classes that
| start with prefix. Usage:
|
| removeClassByPrefix(document.querySelector('.el'), "class-");
|
*/
function removeClassByPrefix(node, prefix) {
  var regx = new RegExp("\\b" + prefix + "[^ ]*[ ]?\\b", "g");
  node.className = node.className.replace(regx, "");
  return node;
}

/*
|-----------------------------------------
| Image Hover Zoom
|-----------------------------------------
| Zooms image on hover.
|
*/
var zoom = function (e) {
  if (window.innerWidth > 800) {
    var zoomer = e.currentTarget;
    e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
    e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
    x = (offsetX / zoomer.offsetWidth) * 100;
    y = (offsetY / zoomer.offsetHeight) * 100;
    zoomer.style.backgroundPosition = x + "% " + y + "%";
  }
};

/*
|-----------------------------------------
| Get Recently Viewed Items
|-----------------------------------------
| Returns list of recently viewed items
| from local storage.
*/
var getRecentlyViewed = function () {
  var $recentlyViewed = localStorage.getItem("recentlyViewed");
  var $items = JSON.parse($recentlyViewed);
  if ($items !== null && $items[0] !== undefined) {
    let sortedItems = $items.sort(function (a, b) {
      return a.timestamp - b.timestamp;
    });
    return sortedItems;
  } else {
    return [];
  }
};

/*
|-----------------------------------------
| Save Recently Viewed Item
|-----------------------------------------
| Saves item to local storage data.
| @param $handle (string) - Product handle
*/
var saveRecentlyViewedProduct = function ($handle) {
  var $recentlyViewed = getRecentlyViewed();
  var exists = false;
  var maxItems = 5;
  $recentlyViewed.forEach(function (item, index) {
    if (item.handle == $handle) {
      exists = true;
    }
  });

  if (exists === false) {
    // Trim the array
    $recentlyViewed.splice(maxItems);
    // Append the new data to the $recentyViewed array
    $recentlyViewed.unshift({
      handle: $handle,
      date: Date.now(),
    });
    // Re-save the updated data back to local storage
    localStorage.setItem("recentlyViewed", JSON.stringify($recentlyViewed));
  }

  // Reload the recentlyViewed list
  getRecentlyViewed();
};

/*
|-----------------------------------------
| Displays Recently Viewed Items
|-----------------------------------------
| Displays the items on the page. This looks for
| .js--recently_viewed.
*/
var displayRecentlyViewed = function () {
  let items = getRecentlyViewed();
  const el = document.getElementById("js--recently_viewed");
  if (document.getElementById("recently-viewed") != null) {
    if (items.length > 0) {
      items.forEach(function (item, index) {
        let url = `/products/${item.handle}?view=grid-item`;
        fetch(url, {
          method: "GET",
          redirect: "error",
        })
          .then(function (response) {
            if (response.ok) {
              return response.text();
            }
          })
          .then(function (htmlContent) {
            // Set the order here.
            htmlContent = htmlContent.replace(
              'class="product-card"',
              'class="product-card" style="order:' + index + ';"'
            );
            el.insertAdjacentHTML("beforeend", htmlContent);
          })
          .catch(function (error) {
            // Remove this item from the array.
            console.log(error); // @debug
            let cleanUpArray = items.filter((i) => i.handle != item.handle);
            localStorage.setItem("recentlyViewed", JSON.stringify(cleanUpArray));
          });
      });
    } else {
      document.getElementById("recently-viewed").style.display = "none";
    }
  }
};
displayRecentlyViewed();
